import { gql } from 'apollo-angular';

/**
 * Language schema
 */
export class LanguageSchema {
	/**
	 * Mutation: updateCompany
	 */
	static readonly setSessionCulture = gql`
		mutation SetSessionCulture($culture: String!) {
			setSessionCulture(culture: $culture)
		}
	`;
	/**
	 * Query for getConnectionDetails
	 */

	static readonly getConnectionDetails = gql`
		query GetConnectionDetails {
			getConnectionDetails {
				countryCode
				enableCaptcha
			}
		}
	`;
}
